import { Avatar, AvatarProps } from "@chakra-ui/react"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { AvatarUser } from "./types"
import { getAvatarFallbackBG, getImage } from "./utils"

type UserAvatarProps = {
  user: AvatarUser
  preferIcon?: boolean
} & AvatarProps

// Dumb component that accepts the group.
export const UserAvatar = ({
  user,
  preferIcon,
  ...avatarProps
}: UserAvatarProps) => {
  // Get standard fallback avatar color.
  function getBgColor(user: AvatarUser) {
    const color = getAvatarFallbackBG(user)
    // Don't provide bg color when image is available.
    return getImage(user) ? undefined : color
  }

  const image = getImage(user)
  const bg = getBgColor(user)
  // Use icon when preferred, when there is no image.
  const useIcon = preferIcon && !image

  return useIcon ? (
    <Avatar
      bg={bg}
      icon={<Pathicon icon="avatar-fill" size="60%" />}
      {...avatarProps}
    />
  ) : (
    <Avatar
      name={user.full_name!}
      src={image}
      bg={bg}
      {...avatarProps}
    />
  )
}

export default UserAvatar
